import { createChannel, createClient } from 'nice-grpc-web';
import { PRD_ENDPOINT } from '@/api/common';
import { api, notification } from '@zentrains/api';

const prdChannel = createChannel(PRD_ENDPOINT);
export const prdApi: api.v3.ZenTrainsClient = createClient(api.v3.ZenTrainsDefinition, prdChannel);
export const prdNotificationApi: notification.v3.NotificationClient = createClient(
  notification.v3.NotificationDefinition,
  prdChannel,
);
